import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { KnowledgebaseAPI } from "../../api/knowledgebase";
import "../../components/knowledgebase/KbEditor.css";

export default function KbArticleList() {
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("all");
  useEffect(() => {
    let active = true;
    KnowledgebaseAPI.list().then((r) => { if (active) setArticles(r.data || []); })
      .catch((e) => { if (active) setError(e.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const shown = useMemo(() => articles.filter((a) =>
    (filter === "all" || (filter === "published" ? a.is_published : !a.is_published)) &&
    (a.title || "").toLowerCase().includes(query.toLowerCase().trim())
  ), [articles, query, filter]);
  return <main className="kbv2-page kbv2-library">
    <div className="kbv2-library-hero"><div><div className="kbv2-eyebrow">NIGHTJAR / KNOWLEDGE</div><h1>Knowledge Base</h1><p>Guides, documentation and answers, all in one place.</p></div>
      <Link className="kbv2-btn kbv2-btn-primary" to="/knowledgebase/articles/new">+ New article</Link></div>
    <div className="kbv2-library-panel">
      <div className="kbv2-library-tools"><label className="kbv2-search"><span aria-hidden="true">⌕</span><input aria-label="Search articles" placeholder="Search articles…" value={query} onChange={(e) => setQuery(e.target.value)} /></label>
        <div className="kbv2-filters" role="group" aria-label="Filter articles">{[["all","All"],["published","Published"],["draft","Drafts"]].map(([key,label]) => <button key={key} type="button" className={filter === key ? "active" : ""} onClick={() => setFilter(key)}>{label}</button>)}</div></div>
      {error && <p className="kbv2-error" role="alert">{error}</p>}
      {loading ? <div className="kbv2-empty">Loading articles…</div> : !error && shown.length === 0 ? <div className="kbv2-empty">{articles.length ? "No articles match your search." : "No articles available yet."}</div> :
        <div className="kbv2-article-list">{shown.map((a) => <div className="kbv2-article-row" key={a.id}><div className="kbv2-article-icon">▤</div><div className="kbv2-article-details"><Link to={`/knowledgebase/articles/${a.id}`}>{a.title || "Untitled article"}</Link><span>{a.is_published ? "Published article" : "Unpublished draft"}</span></div><span className={`kbv2-pill ${a.is_published ? "published" : ""}`}>{a.is_published ? "Published" : "Draft"}</span><Link className="kbv2-row-edit" to={`/knowledgebase/articles/${a.id}/edit`}>Edit →</Link></div>)}</div>}
    </div>
  </main>;
}
